import classes from '../notificationSettings.scss';
import { getLocalizedStrings } from '../../profileSettingsLocalizedStrings';
import DeleteVoice from './deleteVoice';
import TextBox from "./newVoiceTextBox";
import RadioButton from "../../Common/TwoFactorAuthentication/Common/ReactRadioGroup";

const VoicePreferences = (props) => {
  const removeIcon = drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/Action_Remove.svg';
  const warningIcon = drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/Icon_Warning.svg';
  const infoIcon = drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/Icon_Information.svg';
  let strings = getLocalizedStrings('NotificationSettings');
  return(
    <div>
      {props.data.voice.map((obj,index)=>(
         <div>
                  {((props.editButton) && (obj.encryptedvalue === props.encEditVoiceValue)) ?
           <div>
           <div className={classes.box}>       
             <span lassName={classes.textBox}>
             <div className={'row'}>
             <div className={'col-xs-10 ' + classes.textboxAlign}>
             <TextBox type={props.type} placeholder={props.placeHolder} maxLength={props.maxLength}
              validator={app.appUtil.validator} voiceCallback={props.voiceCallback}   textValue={(props.newText!=="") ? props.newText : ""} />
              </div>
              <div className={'col-xs-2 '}>
              <span className={classes.infoIcon} ><button className={classes.sceImageButton} aria-label="Info icon"><img src={infoIcon} alt="Info Icon" /></button> <div className={obj.sequenceNumber === 1 || index === 0 ? classes.infoPopupViewAll :classes.infoPopup}>{strings.infoPopupText}</div></span> 
              </div>
              </div>
               <div>{props.voicePrefErr ? <div className={classes.warningBox}>  <span className={classes.warningImg}><img src={warningIcon} alt="Warning Icon" /></span> <span className={classes.warnMsg}>{strings.lessThanMsg1} {props.voiceData.preferenceError.join(', ')}{". "}{strings.lessThanMsg2}</span></div>:''}</div>
             {/* <span className={classes.radio}>
                    <RadioButton setName={'editLanguageRadioOptions'} options={props.radioButton.labels} type='radio' validStyle={props.radioButton.validStyle} radioOutLineFlag={props.radioButton.outlineStyle} selectedOptions={props.radioButton.phoneType} onClick={props.phoneTypeHandler} />
            </span> */}
               <div>              
               <button className={classes.SaveButton} onClick={()=>{props.saveButtonHandler();}} disabled={props.disabledVoice}>{strings.SaveButtonValue}</button>
              <button className={classes.CancelButton} onClick={props.cancelButtonHandler}>{strings.CancelButtonValue}</button>

               </div>
             </span>
             {props.voiceExistErrMsg ? <span className={classes.errMsg}>{props.voiceExistErrMsg}</span> : null}
             
             {props.modifyVoiceError ? <span className={classes.errMsg}>{strings.errorMsg}</span> : null}
           </div>
         </div>
                 :
                 <div>
            {(props.voiceData.removeVoicePressed && obj.encryptedvalue === props.voiceData.removeVoice) ? <div className={classes.viewAllDeleteData}> <DeleteVoice voice={obj.sequenceNumber} phoneNo={obj.maskedNumber} data={props.data} voiceData={props.voiceData} deleteButtonHandler={props.deleteButtonHandler} removeCancelHandler={props.removeCancelHandler} /></div>
              :
              <div>
                 <div className={classes.row2}>
                  <div className={classes.viewAll}>
                  <button className={classes.sceImageButton} id={obj.encryptedvalue+""+strings.voiceEdit} onClick={(event) => props.removeHandler(event,obj.encryptedvalue)}><img className={classes.viewallRemoveImg} src={removeIcon} alt='Remove Icon' /></button> 
                  <span className={classes.edititem}> {obj.maskedNumber}
                  {/*  Sonar Cube fix 
                        Done by : Keerthi VL
                        Date : 23-01-2023
                */ }
                  <span>{obj.twoFAVerified.toLowerCase() === "true" ? props.isLandlineOrMobile(obj.indicatorTelephone,true) :""}</span> </span>
                  </div>
                  <div className={classes.viewAllEditpadding}><button className={classes.viewAllEditButton}s id={obj} onClick={(event, text) => props.editHandler(event, obj.maskedNumber,obj)}>{strings.editBtn}</button></div>
                  </div>
                   {/*  Sonar Cube fix 
                        Done by : Keerthi VL
                        Date : 23-01-2023
                */ }
             {!(obj.twoFAVerified.toLowerCase() === "true") ?   <div className={classes.verifyLink} > <a className={classes.aVerifyLink}  href="JavaScript:void(0)"  onClick={()=>props.verifyHandler(app.appUtil.maskPhoneX(obj.maskedNumber),'ViewAllPhone','V',obj.encryptedvalue,obj.sequenceNumber,props.isLandlineOrMobile(obj.indicatorTelephone,false))}> {strings.verifyPhone}</a> </div> : null }

              </div>
        
      }
       </div>
              
              }
            <div className={classes.dividerLine1} />

          </div> ))} 
    </div>
  );
};
export default VoicePreferences;